import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import ContentLayout from 'components/Common/ContentLayout';
import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import ListIcon from '@mui/icons-material/List';

const SuperAdminDashboard = () => {
  const { cur_user } = useContext(GlobalContext);
  if (cur_user.bite_super_admin === false) {
    return <Redirect to='/' />;
  }
  return (
    <ContentLayout title='Super Admin Dashboard'>
      <Grid container spacing={4} className='justify-content-center'>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <div className='home-dashboard-info'>
            <Link to='/team-access' className='hover-box'>
              <div className='home-icon-box'>
                <ListIcon fontSize='large' />
              </div>
              <h2>User Teams</h2>
            </Link>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <div className='home-dashboard-info'>
            <Link to='/service-account-access' className='hover-box'>
              <div className='home-icon-box'>
                <ListIcon fontSize='large' />
              </div>
              <h2>Service Accounts</h2>
            </Link>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <div className='home-dashboard-info'>
            <Link to='/manual-team-setup' className='hover-box'>
              <div className='home-icon-box'>
                <ListIcon fontSize='large' />
              </div>
              <h2>Manual Team Setup</h2>
            </Link>
          </div>
        </Grid>
      </Grid>
    </ContentLayout>
  );
};

export default SuperAdminDashboard;
